import React from "react";

import ShareButtonWrapper from "./shareButtonWrapper";
import { ReactComponent as LinkedinIcon } from "../../../semantic/assets/images/share/linkedin.svg";

const LinkedInShare = (props) => {
  const text = props.text ? props.text : "";
  const classNames = props.classNames ? props.classNames : "";
  const url = `https://www.linkedin.com/shareArticle?mini=true&url=${props.url}`;

  return (
    <ShareButtonWrapper url={url} onClick={props.onClick}>
      <div className={classNames}>
        {props.children}
        {!props.children && (
          <div>
            <LinkedinIcon />
            {text}
          </div>
        )}
      </div>
    </ShareButtonWrapper>
  );
};

export default LinkedInShare;
